export default __webpack_public_path__ + "assets/partly-cloudy-night-drizzle.0989c362.svg";